<template>
    <v-dialog v-model="dialog" width="1000" :fullscreen="isMobileOrTablet()" persistent>
        <v-card class="rounded-lg" style="display: flex; flex-direction: column; height: 100%;">
            <v-card-title style="background-color: #1a5b0f !important; display: flex; justify-content: space-between; align-items: center;">
                <div>
                    <span class="font-weight-bold text-h6 text-white">{{ dialog_title }}</span>
                    <div class="text-caption text-white">{{ dialog_sub_title }}</div>
                </div>
                <v-btn v-if="loading == false" flat icon color="darkGreen" @click="closeDialog()">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </v-card-title>
            <v-divider></v-divider>
            <v-card-text style="overflow-y: auto; max-height: calc(100vh - 100px);">
                <v-form ref="form" class="mt-2">
                    <v-row dense>
                        <v-col cols="12" md="6">
                            <v-autocomplete
                                v-model="programId"
                                clearable
                                label="Program"
                                variant="outlined"
                                rounded="lg"
                                color="darkGreen"
                                :items="programData"
                                item-title="name"
                                item-value="id"
                                >
                            </v-autocomplete>
                        </v-col>
                        <v-col cols="12" md="6">
                            <v-autocomplete
                                v-model="officeId"
                                clearable
                                label="Institute/Office"
                                variant="outlined"
                                rounded="lg"
                                color="darkGreen"
                                :items="officeData"
                                item-title="name"
                                item-value="id"
                                >
                            </v-autocomplete>
                        </v-col>
                        <v-col cols="12" md="4">
                            <v-autocomplete
                                v-model="roleId"
                                :rules="[formRules.required]"
                                label="Role"
                                variant="outlined"
                                rounded="lg"
                                color="darkGreen"
                                :items="roleData"
                                item-title="name"
                                item-value="id"
                                >
                            </v-autocomplete>
                        </v-col>
                        <v-col cols="12" md="8">
                            <v-text-field
                                v-model="designation"
                                label="Designation for Document Assignatories"
                                variant="outlined"
                                rounded="lg"
                                type="text"
                                color="darkGreen"
                                >
                            </v-text-field>
                        </v-col>
                    </v-row>
                </v-form>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions class="pa-3" style="margin-top: auto;">
                <v-spacer></v-spacer>
                <v-btn class="mr-1" :disabled="loading" text="Cancel" variant="outlined" elevation="1" @click="closeDialog()"></v-btn>
                <v-btn class="mr-1" :loading="loading" text="Save" variant="elevated" elevation="1" color="darkGreen" @click="validateForm()"></v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import axios from 'axios';
import { defineComponent } from 'vue'
import { useSnackbar } from '@/composables/useSnackbar'

export default defineComponent({
     emits: ["refresh"],
     data(){
        return {
            dialog: false,
            dialog_title: null,
            dialog_sub_title: null,
            action: null,
            loading: false,

            id: null,
            userId: null,
            roleId: null,
            programId: null,
            officeId: null,
            designation: null,

            programData: [],
            officeData: [],
            roleData: [],
        }
     },
     methods: {
        initAdd(id){
            this.dialog = true
            this.dialog_title = 'Role Management'
            this.dialog_sub_title = 'Add new role information'
            this.action = 'add'
            this.initForm()

            this.userId = id
        },
        initUpdate(data){
            this.dialog = true
            this.dialog_title = 'Role Management'
            this.dialog_sub_title = 'Edit new role information'
            this.action = 'edit'
            this.initForm()

            this.id = data.id
            this.userId = data.userId
            this.roleId = data.roleId
            this.programId = data.programId
            this.officeId = data.officeId
            this.designation = data.designation
        },
        async initForm(){
            await axios.get(process.env.VUE_APP_SERVER_URL + '/offices/getAllOffices')
            .then(res => {
                this.officeData = res.data
            });

            await axios.get(process.env.VUE_APP_SERVER_URL + '/programs')
            .then(res => {
                this.programData = res.data
            });

            const token = localStorage.getItem('aums-token')
            axios.get(process.env.VUE_APP_SERVER_URL + '/roles',
            { headers:
                { 
                    'Authorization': `Bearer ${token}`,
                }
            }
            ).then((res)=>{
                if(res.data){
                    this.roleData = res.data
                }
            }).catch((error)=>{
                if(error.response.status == 401){
                    this.loading = false
                    showSnackbar('Token expired! Logging out..')

                    localStorage.removeItem("vuex");
                    localStorage.removeItem("aums-token");
                    window.location.reload();
                }
                else{
                    console.log(error)
                }
            });
        },
        async validateForm(){
            const { showSnackbar } = useSnackbar()
            const { valid } = await this.$refs.form.validate()

            if(valid){
                this.loading = true
                let formData = {
                    id: this.id,
                    userId: this.userId,
                    roleId: this.roleId,
                    programId: this.programId,
                    officeId: this.officeId,
                    designation: this.designation
                }

                const token = localStorage.getItem('aums-token')

                if(this.action == 'add')[
                    axios.post(process.env.VUE_APP_SERVER_URL + '/user-designation', formData,
                    { headers:
                        { 
                            'Authorization': `Bearer ${token}`,
                        }
                    }
                    ).then((res)=>{
                        if(res.data.status == 200){
                            this.loading = false
                            this.$emit('refresh')
                            showSnackbar('Role successfully added!')
                            this.$refs.form.reset()
                            this.dialog = false
                        }
                    }).catch((error)=>{
                        if(error.response.status == 401){
                            this.loading = false
                            showSnackbar('Token expired! Logging out..')

                            localStorage.removeItem("vuex");
                            localStorage.removeItem("aums-token");
                            window.location.reload();
                        }
                        else{
                            console.log(error)
                        }
                    })
                ]
                else if(this.action == 'edit'){
                    axios.patch(process.env.VUE_APP_SERVER_URL + '/user-designation/' + this.id, formData,
                    { headers:
                        { 
                            'Authorization': `Bearer ${token}`,
                        }
                    }
                    ).then((res)=>{
                        if(res.data.status == 200){
                            this.loading = false
                            this.$emit('refresh')
                            showSnackbar('Role successfully updated!')
                            this.$refs.form.reset()
                            this.dialog = false
                        }
                    }).catch((error)=>{
                        if(error.response.status == 401){
                            this.loading = false
                            showSnackbar('Token expired! Logging out..')

                            localStorage.removeItem("vuex");
                            localStorage.removeItem("aums-token");
                            window.location.reload();
                        }
                        else{
                            console.log(error)
                        }
                    })
                }
            }
        },
        closeDialog(){
            this.$refs.form.reset()
            this.dialog = false
        }
     }
})
</script>

<style scoped>

</style>